module.exports = __webpack_public_path__ + "d3ab76fb1054b0e37a0f8e6eaca58d7d.jpg";